import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TextInput, PhoneNumberInput, Checkbox } from 'hosman-material';
import { Error } from '../../../../../../components/BuyerAlertForms/CriteriasForm/components/Inputs/Error';
import { EXTERNAL_SPONSORSHIP_CGU_URL } from '../../../../../../../../shared/helpers/sponsorshipHelper';

import { updateGodsonForm, updateFormErrors } from '../../../../../../reducers/_Pages/sponsorshipModuleSlice';

const Inputs = () => {
  const dispatch = useDispatch();
  const { formErrors, godsonForm } = useSelector((state) => state.sponsorshipModule);

  const handleChange = (e) => {
    const { name, value } = e.target;

    dispatch(updateFormErrors({ ...formErrors, [name]: null }));
    dispatch(updateGodsonForm({ ...godsonForm, [name]: value }));
  };

  return (
    <>
      <div className='flex flex-col md:flex-row gap-3 w-full'>
        <TextInput
          name='first_name'
          label='Prénom'
          placeholder='Pierre'
          onChange={handleChange}
          value={godsonForm.first_name}
          errors={formErrors}
        />

        <TextInput
          name='last_name'
          label='Nom'
          placeholder='Mondaint'
          onChange={handleChange}
          value={godsonForm.last_name}
          errors={formErrors}
        />
      </div>

      <div className='flex flex-col gap-3 w-full'>
        <div className='w-full'>
          <TextInput
            name='email'
            label='Adresse mail'
            placeholder='pierremondaint@gmail.com'
            onChange={handleChange}
            value={godsonForm.email}
            errors={formErrors}
          />
        </div>

        <div className='w-full'>
          <PhoneNumberInput
            name='phone_number'
            onChangePhone={(val) => handleChange({ target: { name: 'phone_number', value: val }})}
            onChangeCountryCode={(val) => handleChange({ target: { name: 'phone_country_code', value: val }})}
            phoneValue={godsonForm.phone_number}
            countryCodeValue={godsonForm.phone_country_code}
            errors={formErrors}
            placeholder='06 77 88 29 63'
          />
        </div>

        <div className='w-full'>
          <div className='flex items-start'>
            <div className='w-fit'>
              <Checkbox
                name='godson_agreement'
                isChecked={!!godsonForm.godson_agreement}
                onChange={() => handleChange({ target: { name: 'godson_agreement', value: !godsonForm.godson_agreement }})}
                small
              />
            </div>

            <label htmlFor='godson_agreement' className='text-sm text-ih-indigo cursor-pointer'>
              <span className='font-semibold'>Je certifie</span> avoir obtenu l'accord du filleul pour qu'il soit contacté par un expert immobilier Hosman. J'accepte les <a href={EXTERNAL_SPONSORSHIP_CGU_URL} target='_blank' className='underline'>CGU</a> du parrainage Hosman.
            </label>
          </div>

          <Error name='godson_agreement' errors={formErrors} />
        </div>
      </div>
    </>
  )
};

export default Inputs;
